// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import GetMembershipStatusRequestModel from '../../model/get-membership-status-request-model';
import GetMembershipStatusRequestDTO from '../dto/get-membership-status-request-dto';
import dtoSchema from '../schemas/get-membership-status-request-schema';

export default abstract class GetMembershipStatusRequestModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<GetMembershipStatusRequestDTO>) {
    super();
    if (data) {
      this.membershipKey = data.membershipKey;
    }
  }
  /**
  */
  membershipKey?: string;

  static toModel(dto: DeepPartial<GetMembershipStatusRequestDTO>): GetMembershipStatusRequestModel;
  static toModel(dto: DeepPartial<GetMembershipStatusRequestDTO> | undefined | null): GetMembershipStatusRequestModel | undefined;
  static toModel(dto: DeepPartial<GetMembershipStatusRequestDTO> | undefined | null): GetMembershipStatusRequestModel | undefined {
    return dto ? new GetMembershipStatusRequestModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<GetMembershipStatusRequestModel> | GetMembershipStatusRequestModel): GetMembershipStatusRequestDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      membershipKey: unwrapped.membershipKey,
    } as GetMembershipStatusRequestDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for GetMembershipStatusRequestModel, can not map to GetMembershipStatusRequestDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
